import logo from './logo.svg';
import './App.css';
import Homepage from "./Home/Homepage";


function App() {
  return (
   <Homepage/>
  );
}

export default App;
